import axios from 'axios'

export const axiosInstance = axios.create({
  // baseURL: 'http://localhost:22333/api',
  baseURL: process.env.REACT_APP_API_URL || 'https://api.rateauditor.org/api',
  timeout: 15000,
})
